/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LuogoResDto } from '../../models/luogo-res-dto';

export interface LuoghiControllerFindLuogoByAutocomplete$Params {
  q: string;
  flagAttivo?: number;
  statiEsteri?: number;
}

export function luoghiControllerFindLuogoByAutocomplete(
  http: HttpClient,
  rootUrl: string,
  params: LuoghiControllerFindLuogoByAutocomplete$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<LuogoResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    luoghiControllerFindLuogoByAutocomplete.PATH,
    'get',
  );
  if (params) {
    rb.query('q', params.q, {});
    rb.query('flagAttivo', params.flagAttivo, {});
    rb.query('statiEsteri', params.statiEsteri, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LuogoResDto>>;
      }),
    );
}

luoghiControllerFindLuogoByAutocomplete.PATH = '/luoghi/cerca';
